import React from "react"
import { useQuery } from "utilities/routes"

const DevOnly = ({ children }: { children: React.ReactNode }) => {
  const query = useQuery()
  const showDevTools = query.get("showDevTool") === "1"

  if (!showDevTools) return null

  return <>{children}</>
}

export default DevOnly
